import { decimalToHexStr } from "utils/numbers";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.old.colors.white};
  border-radius: 8px;
  padding: 8px;
  
  width: 100%;
  max-width: 400px;

  & > div {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
  }

  ${({ theme }) => theme.old.breakpoints.isTab} {
    justify-content: center;
    max-width: unset;
  }
`

export const OptionBtn = styled.button`
  background-color: ${({ theme }) => theme.old.colors.transparent};

  color: ${({ theme, $isActive }) => $isActive
    ? theme.old.colors.primary
    : theme.old.colors.gray[450]
  };

  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};
  cursor: pointer;

  border: none;
  border-radius: 6px;
  padding: 8px 0;
  width: 100%;
  height: 35px;

  :hover {
    color: ${({ theme }) => theme.old.colors.purple[600]};
  }
`

export const SelectedBg = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);

  transition: left 400ms;

  background-color: ${({ theme }) => `${theme.old.colors.primary}${decimalToHexStr(.1)}`};
  color: ${({ theme }) => theme.old.colors.primary};
  font-size: ${({ theme }) => theme.old.fonts.size.smaller};
  font-weight: ${({ theme }) => theme.old.fonts.weight.semibold};

  border: none;
  border-radius: 6px;
`
